export default __webpack_public_path__ + "static/InterDisplay-ThinItalic-a7abf9c53076911da09cc255f40925b1.woff";